import React, { useState, useEffect, Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import _ from 'lodash';
import { Link } from 'gatsby';
import slugify from 'slugify';

const makeChild = (product, index) => {
  return (
    <Fragment key={index}>
      <li>
        <Link to={`/${_.toLower(product.page)}/`}>{product.name}</Link>
      </li>
    </Fragment>
  );
};

const renderGroupedProductCategory = (navItem, NAV_CATEGORIES) => {
  const group = NAV_CATEGORIES[navItem];
  const wrapper = useRef(null);
  const [ariaExpanded, setAriaExpanded] = useState(false);

  const handleClick = () => {
    setAriaExpanded(!ariaExpanded);
  };

  const handleClickOutside = (event) => {
    if (wrapper.current && !wrapper.current.contains(event.target)) {
      setAriaExpanded(false);
    }
  };

  useEffect(() => {
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
  return (
    <li key={navItem} ref={wrapper} className="menu dropdown">
      <button
        className={`button clear menu toggle ${
          ariaExpanded === true ? 'open' : 'closed'
        }`}
        id={slugify(_.toLower(navItem))}
        aria-controls={slugify(_.toLower(navItem))}
        aria-expanded={ariaExpanded}
        role="heading"
        aria-level="2"
        onClick={handleClick}
      >
        {group.meta.groupName}
      </button>
      <div
        className={`${
          group.meta.displayColumns === true
            ? 'submenu submenu__has-columns'
            : 'submenu'
        }`}
        role="region"
        aria-labelledby={slugify(_.toLower(navItem))}
      >
        <ul
          className={
            (group.meta.displayColumns && `${'submenu--columns'}`) || null
          }
        >
          {_.map(group.products, makeChild)}
        </ul>
        {group.meta.more && (
          <Link className="submenu--more" to={`/${group.meta.more}`}>
            View complete list of organic {group.meta.groupName}
          </Link>
        )}
      </div>
    </li>
  );
};

const renderAccordionItem = (navItem, NAV_CATEGORIES) => {
  const group = NAV_CATEGORIES[navItem];
  return (
    <AccordionItem key={navItem}>
      <AccordionItemHeading>
        <AccordionItemButton key="button">
          <i className="fi-plus"></i>
          {group.meta.groupName}
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        <ul>
          {_.map(group.products, makeChild)}
          {group.meta.more && (
            <Link
              key={'complete-list'}
              className="submenu--more"
              to={`/${group.meta.more}`}
            >
              View complete list of organic {group.meta.groupName}
            </Link>
          )}
        </ul>
      </AccordionItemPanel>
    </AccordionItem>
  );
};
const renderMobileNav = (NAV_CATEGORIES) => {
  const wrapper = useRef(null);
  const [ariaExpanded, setAriaExpanded] = useState(false);

  const handleClick = () => {
    setAriaExpanded(!ariaExpanded);
  };

  const handleClickOutside = (event) => {
    if (wrapper.current && !wrapper.current.contains(event.target)) {
      setAriaExpanded(false);
    }
  };

  useEffect(() => {
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });

  return (
    <li key={'shop-all'}>
      <button
        className={`button clear menu toggle ${
          ariaExpanded === true ? 'open' : 'closed'
        }`}
        id="mobile-menu"
        aria-controls="mobile-menu"
        aria-expanded={ariaExpanded}
        role="heading"
        aria-level="2"
        onClick={handleClick}
      >
        Shop all organic plants
      </button>
      <div className="submenu" role="region" aria-labelledby="mobile-menu">
        <Accordion allowZeroExpanded className="nav__mobile--accordion">
          {_.map(Object.keys(NAV_CATEGORIES), (navItem) =>
            renderAccordionItem(navItem, NAV_CATEGORIES),
          )}
        </Accordion>
      </div>
    </li>
  );
};

const ProductCategories = () => {
  const data = useStaticQuery(graphql`
    query HeaderQuery {
      site {
        siteMetadata {
          siteCategories {
            herbs {
              meta {
                displayColumns
                groupName
                more
              }
              products {
                name
                page
              }
            }
            vegetables {
              meta {
                displayColumns
                groupName
                more
              }
              products {
                name
                page
              }
            }
            collections {
              meta {
                displayColumns
                groupName
              }
              products {
                name
                page
              }
            }
            all {
              meta {
                displayColumns
                groupName
              }
              products {
                name
                page
              }
            }
            blog {
              meta {
                displayColumns
                groupName
              }
              products {
                name
                page
              }
            }
          }
        }
      }
    }
  `);
  const NAV_CATEGORIES = data.site.siteMetadata.siteCategories;
  return (
    <>
      <ul className="menu show-for-medium">
        {_.map(Object.keys(NAV_CATEGORIES), (navItem) =>
          renderGroupedProductCategory(navItem, NAV_CATEGORIES),
        )}
        <li>
          <Link to="/gift-cards">Gift cards</Link>
        </li>
      </ul>
      <ul className="menu show-for-small-only nav__mobile">
        {renderMobileNav(NAV_CATEGORIES)}
      </ul>
    </>
  );
};

ProductCategories.propTypes = {
  wrapperElement: PropTypes.string,
};

ProductCategories.defaultProps = {
  wrapperElement: 'span',
};

export default ProductCategories;
